import {useContext, useEffect, useRef, useState} from 'react'
import _ from 'lodash'
import {Button, Input} from 'semantic-ui-react'
import {DataSourceTemplates, DataSourcesContext} from '@/features/data-sources'
import {IFieldDescriptor, IMixerChannelData} from '@/features/mixer'
import {
  ExpressionEditor,
  IExpressionConfig,
  stringifyExpressionConfig,
} from '@/features/expressions'
import {InitViewTemplate} from '../..'
import './style.css'

export const InitViewExpression: InitViewTemplate = (props: {
  descriptor: IFieldDescriptor
  finalize: (descriptor: IFieldDescriptor, initParams: IExpressionConfig) => void
  data?: IMixerChannelData
}) => {
  const {descriptor, finalize, data} = props
  const {mergedItems, addSource} = useContext(DataSourcesContext)

  const inputRef = useRef<Input>(null)
  const [expressionConfig, setExpression] = useState<IExpressionConfig>(
    data?.initParams || {
      expression: '',
    }
  )

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  // function handleOnKeyDown(e: {key: string})
  // {
  //     if (e.key === 'Enter') handleOnSubmit();
  // }

  function handleOnSubmit() {
    addSource(DataSourceTemplates.expression({catalog: mergedItems, expressionConfig}))
    finalize(
      {
        ...descriptor,
        label: `expression: ${expressionConfig.expression}`,
        sourcePath: `_merged.expression["${stringifyExpressionConfig(expressionConfig)}"]`,
      },
      expressionConfig
    )
  }

  return (
    <div className='init-view expression'>
      <ExpressionEditor
        value={expressionConfig}
        onChange={(e) => setExpression(e)}
        // onRunExpression={() => handleOnSubmit()}
        language={'expression-lang'} // TODO: lang name
      />
      {/* <Input
            ref={inputRef}
            placeholder='Type your expression...'
            value={expression}
            onChange={(_e, {value}) => setExpression(value)}
            onKeyDown={handleOnKeyDown}
        /> */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
        }}
      >
        <Button
          icon='save'
          color='blue'
          content='save'
          onClick={handleOnSubmit}
        />
      </div>
    </div>
  )
}
